import Hero from "@/components/home/Hero";
import ServicesOverview from "@/components/home/ServicesOverview";
import Analytics from "@/components/home/Analytics";
import DataEngineering from "@/components/home/DataEngineering";
import CDP from "@/components/home/CDP";
import AI from "@/components/home/AI";
import About from "@/components/home/About";
import CaseStudies from "@/components/home/CaseStudies";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Karinfinity - Data Analytics & AI Consulting</title>
        <meta 
          name="description" 
          content="Karinfinity provides advanced data analytics and AI consulting services specializing in DTC, ecommerce, and BioScience industries." 
        />
      </Helmet>
      
      <Hero />
      <ServicesOverview />
      <Analytics />
      <DataEngineering />
      <CDP />
      <AI />
      <About />
      <CaseStudies />
    </>
  );
};

export default Home;
